import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyCampaignList = lazyWithRetry(() => import('./campaignList'));
